module.exports = __webpack_public_path__ + "static/media/AB_K18_4.58cbf9fc.jpg";